import e from "./index27.js";
import t from "./index74.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/cssVars/prepareCssVars.js
function n(n, r = {}) {
	let { getSelector: i = y, disableCssColorScheme: a, colorSchemeSelector: o, enableContrastVars: s } = r, { colorSchemes: c = {}, components: l, defaultColorScheme: u = "light", ...d } = n, { vars: f, css: p, varsWithDefaults: m } = t(d, r), h = m, g = {}, { [u]: _, ...v } = c;
	if (Object.entries(v || {}).forEach(([n, i]) => {
		let { vars: a, css: o, varsWithDefaults: s } = t(i, r);
		h = e(h, s), g[n] = {
			css: o,
			vars: a
		};
	}), _) {
		let { css: n, vars: i, varsWithDefaults: a } = t(_, r);
		h = e(h, a), g[u] = {
			css: n,
			vars: i
		};
	}
	function y(e, t) {
		let r = o;
		if (o === "class" && (r = ".%s"), o === "data" && (r = "[data-%s]"), o?.startsWith("data-") && !o.includes("%s") && (r = `[${o}="%s"]`), e) {
			if (r === "media") return n.defaultColorScheme === e ? ":root" : { [`@media (prefers-color-scheme: ${c[e]?.palette?.mode || e})`]: { ":root": t } };
			if (r) return n.defaultColorScheme === e ? `:root, ${r.replace("%s", String(e))}` : r.replace("%s", String(e));
		}
		return ":root";
	}
	return {
		vars: h,
		generateThemeVars: () => {
			let t = { ...f };
			return Object.entries(g).forEach(([, { vars: n }]) => {
				t = e(t, n);
			}), t;
		},
		generateStyleSheets: () => {
			let e = [], t = n.defaultColorScheme || "light";
			function r(t, n) {
				Object.keys(n).length && e.push(typeof t == "string" ? { [t]: { ...n } } : t);
			}
			r(i(void 0, { ...p }), p);
			let { [t]: o, ...l } = g;
			if (o) {
				let { css: e } = o, n = c[t]?.palette?.mode, s = !a && n ? {
					colorScheme: n,
					...e
				} : { ...e };
				r(i(t, { ...s }), s);
			}
			return Object.entries(l).forEach(([e, { css: t }]) => {
				let n = c[e]?.palette?.mode, o = !a && n ? {
					colorScheme: n,
					...t
				} : { ...t };
				r(i(e, { ...o }), o);
			}), s && e.push({ ":root": {
				"--__l-threshold": "0.7",
				"--__l": "clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)",
				"--__a": "clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)"
			} }), e;
		}
	};
}
//#endregion
export { n as default };

//# sourceMappingURL=index75.js.map